// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Bar } from "react-chartjs-2";
// import { BsBoxes } from "react-icons/bs";
// import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
// import LeftSideNavaBarAdmin from "./LeftSideNavaBarAdmin";
// import "./AdminDashBoard.css";
// import { IoWarningOutline } from "react-icons/io5";
// import { BiPackage } from "react-icons/bi";
// import { FaLayerGroup } from "react-icons/fa";
// import { GrMoney } from "react-icons/gr";
// // Register necessary components for Chart.js
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// const AdminDashboard = () => {
//   const [dashboardStats, setDashboardStats] = useState({
//     totalProducts: 0,
//     totalInventoryCount: 0,
//     inStockCount: 0,
//     outOfStockCount: 0,
//     totalOrders: 0,
//     revenue: 0,
//   });
//   const [chartData, setChartData] = useState({
//     labels: [],
//     datasets: [
//       {
//         label: "Total Orders",
//         data: [],
//         backgroundColor: "rgba(75, 192, 192, 0.2)",
//         borderColor: "rgba(75, 192, 192, 1)",
//         borderWidth: 1,
//       },
//       {
//         label: "Total Revenue",
//         data: [],
//         backgroundColor: "rgba(153, 102, 255, 0.2)",
//         borderColor: "rgba(153, 102, 255, 1)",
//         borderWidth: 1,
//       },
//     ],
//   });

//   useEffect(() => {
//     // Fetch dashboard stats from the backend API
//     axios
//       .get("/api/dashboard")
//       .then((response) => {
//         setDashboardStats(response.data);
//         // For the chart, assuming you also have data over time (for example, weekly data)
//         setChartData({
//           labels: ["Week 1", "Week 2", "Week 3", "Week 4"], // Example: You can replace with actual date range
//           datasets: [
//             {
//               ...chartData.datasets[0],
//               data: [response.data.totalOrders, 120, 150, 180], // Replace with actual data over time
//             },
//             {
//               ...chartData.datasets[1],
//               data: [response.data.revenue, 3000, 4500, 5000], // Replace with actual data over time
//             },
//           ],
//         });
//       })
//       .catch((error) => {
//         console.error("Error fetching dashboard stats:", error);
//       });
//   }, []);

//   return (
//     <>
//       <div className="breadcrumb-wrap bg-f ">
        
//         {/* <div className="container">
//           <div className="breadcrumb-title">
//             <h2>Admin Dashboard</h2>
//             <ul className="breadcrumb-menu list-style">
//               <li><a href="/">Home</a></li>
//               <li>Admin Dashboard</li>
//             </ul>
//           </div>
//         </div> */}
//       </div>
//       <div className="containerorder">
//         <div className="row ">
//           <div class="col-xl-2 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
//             <LeftSideNavaBarAdmin /></div>
//           <div className="col-xl-10 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
//             <div className="cardContainer">
//               <div className="card card1">
//                 <div className="iconbox"><BsBoxes size={28} /></div>

//                 <p>{dashboardStats.totalProducts}</p>
//                 <h6>Total Products</h6>
//               </div>
//               {/* <div className="card card2">
//               <div className="iconbox"><FaLayerGroup size={28} /></div>
                
//                 <p>{dashboardStats.totalInventoryCount}</p>
//                 <h6>Total Inventory</h6>
//               </div>
//               <div className="card card3">
//               <div className="iconbox"><BsBoxes size={28} /></div>
//                 <p>{dashboardStats.inStockCount}</p>
//                 <h6>In Stock</h6>
//               </div>
//               <div className="card card4">
//               <div className="iconbox"><IoWarningOutline size={28} /></div>
//                 <p>{dashboardStats.outOfStockCount}</p>
//                 <h6>Out of Stock</h6>
//               </div> */}
//               <div className="card card5">
//               <div className="iconbox"><BiPackage size={28} /></div>
  
//                 <p>{dashboardStats.totalOrders}</p>
//                 <h6>Total Orders</h6>
//               </div>
//               <div className="card card6">
//               <div className="iconbox"><GrMoney  size={28} /></div>
//                 <p>₹{dashboardStats.revenue}</p>
//                 <h6>Total Revenue</h6>
//               </div>
//             </div>
//             <div className="chartContainer">
//               <h2>Orders & Revenue Chart</h2>
//               <Bar data={chartData} options={chartOptions} />
//             </div>
//           </div>
          
//         </div>
//       </div>
//     </>
//   );
// };

// // Chart.js options
// const chartOptions = {
//   responsive: true,
//   scales: {
//     y: {
//       beginAtZero: true,
//     },
//   },
// };


// export default AdminDashboard;

import React, { useEffect, useState } from "react";
import axios from "axios";
import { Bar, Line, Pie } from "react-chartjs-2";
import { BsBoxes } from "react-icons/bs";
import { 
  Chart as ChartJS, 
  CategoryScale, 
  LinearScale, 
  BarElement, 
  LineElement,
  PointElement,
  Title, 
  Tooltip, 
  Legend,
  ArcElement
} from "chart.js";
import LeftSideNavaBarAdmin from "./LeftSideNavaBarAdmin";
import "./AdminDashBoard.css";
import { IoWarningOutline } from "react-icons/io5";
import { BiPackage } from "react-icons/bi";
import { FaLayerGroup } from "react-icons/fa";
import { GrMoney } from "react-icons/gr";

// Register necessary components for Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const AdminDashboard = () => {
  const [dashboardStats, setDashboardStats] = useState({
    totalProducts: 0,
    totalInventoryCount: 0,
    inStockCount: 0,
    outOfStockCount: 0,
    totalOrders: 0,
    revenue: 0,
  });

  // State for chart data
  const [ordersChartData, setOrdersChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Orders",
        data: [],
        borderColor: "rgba(75, 192, 192, 1)",
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        borderWidth: 2,
        tension: 0.1,
      },
    ],
  });

  const [revenueChartData, setRevenueChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Revenue (₹)",
        data: [],
        borderColor: "rgba(153, 102, 255, 1)",
        backgroundColor: "rgba(153, 102, 255, 0.2)",
        borderWidth: 2,
        tension: 0.1,
      },
    ],
  });

  
  const [productsChartData, setProductsChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Products Sold",
        data: [],
        borderColor: "rgba(255, 99, 132, 1)",
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        borderWidth: 2,
        tension: 0.1,
      },
    ],
  });

  // New state for category distribution pie chart
  const [categoryChartData, setCategoryChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Products by Category",
        data: [],
        backgroundColor: [
          'rgba(255, 99, 132, 0.6)',
          'rgba(54, 162, 235, 0.6)',
          'rgba(255, 206, 86, 0.6)',
          'rgba(75, 192, 192, 0.6)',
          'rgba(153, 102, 255, 0.6)',
          'rgba(255, 159, 64, 0.6)',
          'rgba(199, 199, 199, 0.6)',
          'rgba(83, 102, 255, 0.6)',
          'rgba(40, 159, 64, 0.6)',
          'rgba(210, 199, 199, 0.6)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)',
          'rgba(199, 199, 199, 1)',
          'rgba(83, 102, 255, 1)',
          'rgba(40, 159, 64, 1)',
          'rgba(210, 199, 199, 1)',
        ],
        borderWidth: 1,
      },
    ],
  });

  // Individual filter states for each chart
  const [ordersFilter, setOrdersFilter] = useState({
    period: "month",
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  });
  
  const [revenueFilter, setRevenueFilter] = useState({
    period: "month",
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  });
  
  const [productsFilter, setProductsFilter] = useState({
    period: "month",
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  });
  
  const [availableYears, setAvailableYears] = useState([]);
  const [isLoading, setIsLoading] = useState({
    orders: true,
    revenue: true,
    products: true,
    categories: true
  });

  // Fetch dashboard stats
  useEffect(() => {
    axios
      .get("/api/dashboard")
      .then((response) => {
        setDashboardStats(response.data);
      })
      .catch((error) => {
        console.error("Error fetching dashboard stats:", error);
      });
  }, []);

  // Fetch available years for orders data
  useEffect(() => {
    axios
      .get("/api/orders/years")
      .then((response) => {
        const years = response.data.years || [];
        setAvailableYears(years);
        
        // Set default years if available
        if (years.length > 0) {
          const mostRecentYear = years[years.length - 1];
          
          if (!years.includes(ordersFilter.year)) {
            setOrdersFilter(prev => ({...prev, year: mostRecentYear}));
          }
          
          if (!years.includes(revenueFilter.year)) {
            setRevenueFilter(prev => ({...prev, year: mostRecentYear}));
          }
          
          if (!years.includes(productsFilter.year)) {
            setProductsFilter(prev => ({...prev, year: mostRecentYear}));
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching available years:", error);
        // Fallback to current and previous years if API fails
        const currentYear = new Date().getFullYear();
        setAvailableYears([currentYear - 1, currentYear]);
      });
  }, []);

  // Fetch category distribution data
  useEffect(() => {
    setIsLoading(prev => ({...prev, categories: true}));
    
    axios
      .get("/api/products/categories/distribution")
      .then((response) => {
        const { categories } = response.data;
        
        // Update category chart
        setCategoryChartData({
          labels: categories.map(item => item.categoryName),
          datasets: [
            {
              ...categoryChartData.datasets[0],
              data: categories.map(item => item.count),
            },
          ],
        });
        
        setIsLoading(prev => ({...prev, categories: false}));
      })
      .catch((error) => {
        console.error("Error fetching category distribution:", error);
        setIsLoading(prev => ({...prev, categories: false}));
        
        // Set dummy data if API fails
        const dummyCategoryData = [
          { categoryName: "Silver Nano", count: 12 },
          { categoryName: "Home Care", count: 8 },
          { categoryName: "Personal Care", count: 15 },
          { categoryName: "Auto Care", count: 10 },
          { categoryName: "Pet Care", count: 6 }
        ];
        
        setCategoryChartData({
          labels: dummyCategoryData.map(item => item.categoryName),
          datasets: [
            {
              ...categoryChartData.datasets[0],
              data: dummyCategoryData.map(item => item.count),
            },
          ],
        });
      });
  }, []);

  // Fetch orders chart data
  useEffect(() => {
    setIsLoading(prev => ({...prev, orders: true}));
    
    // Determine the API endpoint based on the selected period
    let endpoint = "";
    if (ordersFilter.period === "month") {
      endpoint = `/api/analytics/${ordersFilter.period}/${ordersFilter.year}/${ordersFilter.month}`;
    } else if (ordersFilter.period === "year") {
      endpoint = `/api/analytics/${ordersFilter.period}/${ordersFilter.year}`;
    } else {
      endpoint = `/api/analytics/${ordersFilter.period}`;
    }

    axios
      .get(endpoint)
      .then((response) => {
        const { orders } = response.data;
        
        // Update orders chart
        setOrdersChartData({
          labels: orders.map(item => item.label),
          datasets: [
            {
              ...ordersChartData.datasets[0],
              data: orders.map(item => item.count),
            },
          ],
        });
        
        setIsLoading(prev => ({...prev, orders: false}));
      })
      .catch((error) => {
        console.error("Error fetching orders data:", error);
        setIsLoading(prev => ({...prev, orders: false}));
        
        // Set dummy data if API fails
        const dummyLabels = getDummyLabels(ordersFilter.period);
        setOrdersChartData({
          labels: dummyLabels,
          datasets: [{...ordersChartData.datasets[0], data: generateRandomData(dummyLabels.length, 20)}],
        });
      });
  }, [ordersFilter.period, ordersFilter.year, ordersFilter.month]);

  // Fetch revenue chart data
  useEffect(() => {
    setIsLoading(prev => ({...prev, revenue: true}));
    
    // Determine the API endpoint based on the selected period
    let endpoint = "";
    if (revenueFilter.period === "month") {
      endpoint = `/api/analytics/${revenueFilter.period}/${revenueFilter.year}/${revenueFilter.month}`;
    } else if (revenueFilter.period === "year") {
      endpoint = `/api/analytics/${revenueFilter.period}/${revenueFilter.year}`;
    } else {
      endpoint = `/api/analytics/${revenueFilter.period}`;
    }

    axios
      .get(endpoint)
      .then((response) => {
        const { revenue } = response.data;
        
        // Update revenue chart
        setRevenueChartData({
          labels: revenue.map(item => item.label),
          datasets: [
            {
              ...revenueChartData.datasets[0],
              data: revenue.map(item => item.amount),
            },
          ],
        });
        
        setIsLoading(prev => ({...prev, revenue: false}));
      })
      .catch((error) => {
        console.error("Error fetching revenue data:", error);
        setIsLoading(prev => ({...prev, revenue: false}));
        
        // Set dummy data if API fails
        const dummyLabels = getDummyLabels(revenueFilter.period);
        setRevenueChartData({
          labels: dummyLabels,
          datasets: [{...revenueChartData.datasets[0], data: generateRandomData(dummyLabels.length, 5000)}],
        });
      });
  }, [revenueFilter.period, revenueFilter.year, revenueFilter.month]);

  // Fetch products chart data
  useEffect(() => {
    setIsLoading(prev => ({...prev, products: true}));
    
    // Determine the API endpoint based on the selected period
    let endpoint = "";
    if (productsFilter.period === "month") {
      endpoint = `/api/analytics/${productsFilter.period}/${productsFilter.year}/${productsFilter.month}`;
    } else if (productsFilter.period === "year") {
      endpoint = `/api/analytics/${productsFilter.period}/${productsFilter.year}`;
    } else {
      endpoint = `/api/analytics/${productsFilter.period}`;
    }

    axios
      .get(endpoint)
      .then((response) => {
        const { products } = response.data;
        
        // Update products chart
        setProductsChartData({
          labels: products.map(item => item.label),
          datasets: [
            {
              ...productsChartData.datasets[0],
              data: products.map(item => item.count),
            },
          ],
        });
        
        setIsLoading(prev => ({...prev, products: false}));
      })
      .catch((error) => {
        console.error("Error fetching products data:", error);
        setIsLoading(prev => ({...prev, products: false}));
        
        // Set dummy data if API fails
        const dummyLabels = getDummyLabels(productsFilter.period);
        setProductsChartData({
          labels: dummyLabels,
          datasets: [{...productsChartData.datasets[0], data: generateRandomData(dummyLabels.length, 50)}],
        });
      });
  }, [productsFilter.period, productsFilter.year, productsFilter.month]);

  // Helper function to get dummy labels based on period
  const getDummyLabels = (period) => {
    switch(period) {
      case "month":
        return Array.from({ length: 31 }, (_, i) => (i + 1).toString());
      case "year":
        return ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      case "week":
      default:
        return ["Week 1", "Week 2", "Week 3", "Week 4"];
    }
  };

  // Helper function to generate random data
  const generateRandomData = (length, max) => {
    return Array.from({ length }, () => Math.floor(Math.random() * max));
  };

  // Chart options
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: false
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  // Pie chart options - no need for y-axis scale
  const pieChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "right",
        display: true
      },
      title: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.raw || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            return `${label}: ${value} (${percentage}%)`;
          }
        }
      }
    },
  };

  // Generate months for dropdown
  const months = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];

  // Filter component for reusability
  const FilterControls = ({ title, filter, setFilter, isLoading }) => (
    <div className="chartHeader">
      <h4>{title} {isLoading && "(Loading...)"}</h4>
      <div className="chartFilters">
        <div className="filterGroup">
          <select 
            value={filter.period} 
            onChange={(e) => setFilter({...filter, period: e.target.value})}
            className="form-select form-select-sm"
          >
            <option value="week">Week</option>
            <option value="month">Month</option>
            <option value="year">Year</option>
          </select>
        </div>
        
        <div className="filterGroup">
          <select 
            value={filter.year} 
            onChange={(e) => setFilter({...filter, year: parseInt(e.target.value)})}
            className="form-select form-select-sm"
          >
            {availableYears.map(year => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>
        </div>
        
        {filter.period === "month" && (
          <div className="filterGroup">
            <select 
              value={filter.month} 
              onChange={(e) => setFilter({...filter, month: parseInt(e.target.value)})}
              className="form-select form-select-sm"
            >
              {months.map(month => (
                <option key={month.value} value={month.value}>{month.label}</option>
              ))}
            </select>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      <div className="breadcrumb-wrap bg-f">
        {/* Breadcrumb content if needed */}
      </div>
      <div className="containerorder">
        <div className="row">
          <div className="col-xl-3 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
            <LeftSideNavaBarAdmin />
          </div>
          <div className="col-xl-9 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
            {/* Stats Cards */}
            <div className="cardContainer">
              <div className="card card1">
                <div className="iconbox"><BsBoxes size={28} /></div>
                <p className="heading_mrp_new">{dashboardStats.totalProducts}</p>
                <h6>Total Products</h6>
              </div>
              <div className="card card2">
                <div className="iconbox"><FaLayerGroup size={28} /></div>
                <p className="heading_mrp_new">{dashboardStats.totalInventoryCount}</p>
                <h6>Total Inventory</h6>
              </div>
              <div className="card card3">
                <div className="iconbox"><BsBoxes size={28} /></div>
                <p className="heading_mrp_new">{dashboardStats.inStockCount}</p>
                <h6>In Stock</h6>
              </div>
              <div className="card card4">
                <div className="iconbox"><IoWarningOutline size={28} /></div>
                <p className="heading_mrp_new">{dashboardStats.outOfStockCount}</p>
                <h6>Out of Stock</h6>
              </div>
              <div className="card card5">
                <div className="iconbox"><BiPackage size={28} /></div>
                <p className="heading_mrp_new">{dashboardStats.totalOrders}</p>
                <h6>Total Orders</h6>
              </div>
              <div className="card card6">
                <div className="iconbox"><GrMoney size={28} /></div>
                <p className="heading_mrp_new">₹{dashboardStats.revenue.toFixed(2)}</p>
                <h6>Total Revenue</h6>
              </div>
            </div>
            
            <div className="analyticsHeader">
              <h3>Analytics Dashboard</h3>
            </div>
            
            {/* Orders and Revenue Charts in same row */}
            <div className="chartsRow">
              <div className="chartBox">
                <FilterControls 
                  title="Orders" 
                  filter={ordersFilter} 
                  setFilter={setOrdersFilter} 
                  isLoading={isLoading.orders}
                />
                <div className="chartWrapper">
                  <Line data={ordersChartData} options={chartOptions} height={300} />
                </div>
              </div>
              
              <div className="chartBox">
                <FilterControls 
                  title="Revenue" 
                  filter={revenueFilter} 
                  setFilter={setRevenueFilter} 
                  isLoading={isLoading.revenue}
                />
                <div className="chartWrapper">
                  <Line data={revenueChartData} options={chartOptions} height={300} />
                </div>
              </div>
            </div>
            
            {/* Products Chart and Category Distribution in the same row */}
            <div className="chartsRow">
              <div className="chartBox">
                <FilterControls 
                  title="Products Sold" 
                  filter={productsFilter} 
                  setFilter={setProductsFilter}
                  isLoading={isLoading.products}
                />
                <div className="chartWrapper">
                  <Line data={productsChartData} options={chartOptions} height={300} />
                </div>
              </div>
              
              {/* New Category Distribution Pie Chart */}
              <div className="chartBox">
                <div className="chartHeader">
                  <h4>Product Categories {isLoading.categories && "(Loading...)"}</h4>
                </div>
                <div className="chartWrapper pieChartWrapper">
                  <Pie data={categoryChartData} options={pieChartOptions} height={300} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
